import { createSlice } from "@reduxjs/toolkit";
import { PagamentoContaFinanceiraVWModel } from "../../../models/pagamentoContaFinanceira/pagamentoContaFinanceiraVWModel";
import { buscarPagamentoContaFinanceira } from "../../../services/pagamentoContaFinanceiraService";
import { resetAll } from "../../actions/actions";

export interface PagamentoContaFinanceiraState {
  //buscar pagamento conta financeira
  loading: boolean;
  list: PagamentoContaFinanceiraVWModel[];
  entity: PagamentoContaFinanceiraVWModel;
  //internal
  modalPagamentoUnico: boolean;
  modalDeletarLote: boolean;
  modalDeletar: boolean;
  idContaFinanceira: number;
}

const initialState: PagamentoContaFinanceiraState = {
  //buscar pagamento conta financeira
  loading: false,
  list: [],
  entity: {} as PagamentoContaFinanceiraVWModel,
  //internal
  modalPagamentoUnico: false,
  modalDeletarLote: false,
  modalDeletar: false,
  idContaFinanceira: 0,
};

export const pagamentoContaFinanceiraSlice = createSlice({
  name: "pagamentoContaFinanceira",
  initialState,
  reducers: {
    //buscar pagamento conta financeira
    setEntityPagamentoContaFinanceira: (state, action) => {
      state.entity = action.payload;
    },
    //internal
    setModalPagamentoUnico: (state, action) => {
      state.modalPagamentoUnico = action.payload;
    },
    setModalDeletarLote: (state, action) => {
      state.modalDeletarLote = action.payload;
    },
    setModalDeletarpagamentoContaFinanceira: (state, action) => {
      state.modalDeletar = action.payload;
    },
    setIdContaFinanceira: (state, action) => {
      state.idContaFinanceira = action.payload;
    },
  },
  extraReducers: (builder) => {
    //resetar estados
    builder.addCase(resetAll, () => initialState);

    //buscar pagamento conta financeira
    builder.addCase(buscarPagamentoContaFinanceira.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(buscarPagamentoContaFinanceira.fulfilled, (state, action) => {
      state.list = action.payload;
      state.loading = false;
    });
    builder.addCase(buscarPagamentoContaFinanceira.rejected, (state, action) => {
      state.loading = false;
    });
  },
});

export const {
  //buscar pagamento conta financeira
  setEntityPagamentoContaFinanceira,
  //internal
  setModalPagamentoUnico,
  setModalDeletarLote,
  setModalDeletarpagamentoContaFinanceira,
  setIdContaFinanceira,
} = pagamentoContaFinanceiraSlice.actions;

export default pagamentoContaFinanceiraSlice.reducer;
